export const bannerClasses = {
  compact: 'banner--compact',
  partners: 'banner--partners',
  fullWidthHeading: 'banner--full-width-heading',
  fullSize: 'banner--full-size',
  mainHeaderTransparent: 'banner--main-header-transparent',
  sticky: 'banner--sticky',
  smokyBlack: 'banner--smoky-black',
}

export const BANNER_HEIGHT = {
  DESKTOP: 500,
  MOBILE: 415,
  PARTNER: {
    DESKTOP: 600,
    MOBILE: 578,
  },
  COMPACT: {
    DESKTOP: 374,
    MOBILE: 266,
  },
  FULL_SIZE: {
    DESKTOP: 730,
    MOBILE: 880,
  },
}
